var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'dp-colour-range-slider',
    {
      'dp-colour-range-slider--disabled': _vm.disabled,
      'dp-colour-range-slider--horizontal': _vm.orientation === 'horizontal',
    }
  ]},[_c('div',{ref:"slider",attrs:{"disabled":_vm.disabled}})])}
var staticRenderFns = []

export { render, staticRenderFns }